import { Component, Input, inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CreditCardTypeComponent } from '../credit-card-type/credit-card-type.component';
import { firstValueFrom } from 'rxjs';
import { PaymentMethod } from '../../models/paymentMethod';
import { PaymentService } from '../../services/payment/payment.service';
import { AuthService } from '../../services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericAlertPopupComponent } from '../generic-alert-popup/generic-alert-popup.component';
import { MatRadioButton } from '@angular/material/radio';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-credit-card-item',
	standalone: true,
	imports: [
		MaterialModule,
		PipesModule,
		CreditCardTypeComponent,
		CommonModule
	],
	templateUrl: './credit-card-item.component.html',
	styleUrl: './credit-card-item.component.scss',
})
export class CreditCardItemComponent {

	@ViewChild('radioButton') radio: MatRadioButton;

	private readonly paymentService = inject(PaymentService);
	private readonly authService = inject(AuthService);
	private readonly dialog = inject(MatDialog);

	@Input() paymentMethod: PaymentMethod;
	@Input() allowDelete: boolean = true;
	@Input() selectable: boolean = false;
	@Input() selected: boolean = false;

	@Output() onPaymentMethodDeleted = new EventEmitter<void>();
	@Output() onPaymentMethodSelected = new EventEmitter<PaymentMethod>();

	deleting: boolean = false;
	user = this.authService.auth?.user;

	async openDeleteConfirmationDialog(paymentMethodId: string): Promise<void> {
		const response = await firstValueFrom(this.dialog.open(GenericAlertPopupComponent, {
			data: {
				title: 'account.delete_payment_method_title',
				description: 'account.delete_payment_method_description',
				dismissBtnText: 'general.cancel',
				acceptBtnText: 'general.accept',
				btnColor: 'bg-warn text-accent-lighter'
			},
			width: '30%'
		}).afterClosed());
		if (response) {
			await this.deletePaymentMethod(paymentMethodId);
		}
	}

	async deletePaymentMethod(paymentMethodId: string): Promise<void> {
		this.deleting = true;
		await this.paymentService.delete(this.user?.id, paymentMethodId);
		this.deleting = false;
		this.onPaymentMethodDeleted.emit();
	}

	selectPaymentMethod(): void {
		this.onPaymentMethodSelected.emit(this.paymentMethod);
	}

	setRadioButtonValue(value: boolean): void {
		this.radio.checked = value;
		this.selectPaymentMethod();
	}

}
